import { render, staticRenderFns } from "./ProjectList.vue?vue&type=template&id=587e8fcc&"
import script from "./ProjectList.vue?vue&type=script&lang=js&"
export * from "./ProjectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('587e8fcc')) {
      api.createRecord('587e8fcc', component.options)
    } else {
      api.reload('587e8fcc', component.options)
    }
    module.hot.accept("./ProjectList.vue?vue&type=template&id=587e8fcc&", function () {
      api.rerender('587e8fcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectmanagement/ProjectList.vue"
export default component.exports